import { useEffect, useState } from "react";

function App() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const pstTime = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).format(now);
      setTime(pstTime);
    };

    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "10px",
        padding: isMobile ? "24px 16px" : isTablet ? "36px 24px" : "32px 32px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        overflow: "hidden",
        gap: "10px",
      }}
    >
      <p
        style={{
          border: "1px solid gainsboro",
          width: "fit-content",
          padding: "5px 10px",
          background: "whitesmoke",
          borderRadius: "5px",
        }}
      >
        Atlanta, GA {time}
      </p>
      <h1>Sriram Manikandan</h1>
      <p>
        Computer Science @{" "}
        <a href="https://gatech.edu" style={{ color: "#B3A369", fontWeight: "bold" }}>
          Georgia Institute of Technology
        </a>
      </p>
      <p>
        Co-founder @{" "}
        <a href="https://app.cookr.co" style={{ color: "#000080", fontWeight: "bold" }}>Cookr</a> (80k
        users)
      </p>
      <div
        style={{
          display: "flex",
          gap: "20px",
          position: "absolute",
          bottom: "20px",
        }}
      >
        <a
          href="https://www.linkedin.com/in/the-srirammanikandan"
          style={{
            textDecoration: "none",
            color: "black",
            cursor: "poijter",
          }}
        >
          LinkedIn
        </a>
        <a
          href="https://www.instagram.com/sriram.m572/"
          style={{
            textDecoration: "none",
            color: "black",
            cursor: "poijter",
          }}
        >
          Instagram
        </a>
        <a
          href="https://github.com/srimans573/"
          style={{
            textDecoration: "none",
            color: "black",
            cursor: "poijter",
          }}
        >
          GitHub
        </a>
      </div>
    </div>
  );
}

export default App;
